import axios from "axios"
import getConfig from "next/config"
import { assocPath } from "ramda"
import { TokenCookiesKey } from "../constants/index"
import { getCookie } from "../utils/cookies"

const getUniqueID = () => {
  return Math.random().toString(36).slice(2, 10)
}

export const requestID = getUniqueID()

const http = axios.create()

const { publicRuntimeConfig: config } = getConfig()

const baseUrl = config.baseUrl
const basePath = config.basePath
const ssoUrl = config.ssoUrl
const locationServiceUrl = config.locationServiceUrl

const insertRequestID = (config = {}) => {
  let newConfig = Object.assign({}, config)
  newConfig = assocPath(["headers", "x-request-id"], requestID, newConfig)
  if (getCookie(TokenCookiesKey)) {
    newConfig = assocPath(["headers", "Authorization"], `Bearer ${getCookie(TokenCookiesKey)}`, newConfig)
  }
  return newConfig
}

function load(endpoint, params) {
  const config = insertRequestID()
  if (params?.otaToken) {
    config.headers.Authorization = `Bearer ${params.otaToken}`
  }
  return http.get(`${baseUrl}${endpoint}`, { params, ...config })
}

function create(endpoint, data, configOptions = {}) {
  const config = insertRequestID(configOptions)
  return http.post(`${baseUrl}${endpoint}`, data, config)
}

function update(endpoint, data, configOptions = {}) {
  const config = insertRequestID(configOptions)
  return http.put(`${baseUrl}${endpoint}`, data, config)
}

function upload(endpoint, formData, onUploadProgress, params, cancelToken) {
  const headers = {
    "x-request-id": requestID
  }
  return http.post(`${baseUrl}${endpoint}`, formData, { onUploadProgress, headers, params, cancelToken })
}

function loadSSO(data, configOptions) {
  const config = insertRequestID(configOptions)
  return http.post(`${basePath}services/cms-bff/api/sso_user_profile`, data, config)
}

function loadLocationInfo() {
  return http.get(`${locationServiceUrl}`)
}

export default {
  load,
  create,
  update,
  upload,
  loadSSO,
  loadLocationInfo,
  requestID
}
